import {
  SAVE_DATA_BOOKING_REQUEST,
  SAVE_DATA_BOOKING_SUCCESS,
  RESET_BOOKING_CONFIRM
  } from "./constants";

import { IBookingConfirm } from "./../../../models";


export const saveDataBookingRequest = (payload: IBookingConfirm) => ({
  type: SAVE_DATA_BOOKING_REQUEST,
  payload
});

export const saveDataBookingSuccess = (payload: IBookingConfirm) => ({
  type: SAVE_DATA_BOOKING_SUCCESS,
  payload
});

export const resetDataBooking = () => ({
  type: RESET_BOOKING_CONFIRM
});
